import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFormRhombus: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"form-rhombus"} maskId="square-filled-radius-0-stroke-1-IconFormRhombus"><path d="M19.6602 12L11.998 23.0674L4.33594 12L11.998 0.932617L19.6602 12Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconFormRhombus;
